import { Button, FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';

export const FormControlLabelLGPD = styled(FormControlLabel)`
  .MuiTypography-root {
    font-size: 1.6rem;
    color: #fff;
  }

  svg {
    width: 16px;
    height: 16px;
  }

  .MuiCheckbox-root {
    color: #fff;
  }

  .MuiCheckbox-colorPrimary.Mui-checked {
    color: #1473e6;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #292828;

  @page {
    size: auto;
    margin: 6mm;
  }

  .TextField-lgpd {
    width: 100%;
    max-width: 300px;

    > label {
      color: #929292;
      font-size: 1.4rem;
    }

    .MuiInputBase-root {
      font-size: 1.4rem;

      input {
        color: #fff;
        font-size: 1.4rem;
      }
      fieldset {
        border-color: #929292;
      }
    }
  }

  .header {
    border-bottom: 1px #707070 solid;
    padding-bottom: 20px;

    h1 {
      font-size: 2.8rem;
      color: #fff;
      margin: 0 0 40px 0;
    }

    .login-information {
      & > * {
        margin: 0 20px 30px 0;
      }

      .TextField-lgpd {
        width: 100%;
        max-width: 300px;

        > label {
          color: #929292;
          font-size: 1.4rem;
        }

        .MuiInputBase-root {
          font-size: 1.4rem;

          input {
            color: #fff;
            font-size: 1.4rem;
          }
          fieldset {
            border-color: #929292;
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    padding: 0;

    section {
      border-bottom: 1px #707070 solid;
      padding-bottom: 20px;
      margin-bottom: 60px;

      & > * {
        margin: 0 20px 30px 0;
      }
    }

    h2 {
      color: #fff;
      font-size: 2rem;
      margin: 30px 0 20px;
    }

    h3 {
      color: #fff;
      font-size: 2rem;
      margin: 30px 0 20px;
    }

    .table-lgpd {
      .MuiPaper-root {
        background-color: #292828;
        border: 1px solid #707070;

        .MuiTableHead-root {
          .MuiButtonBase-root {
            font-size: 1.4rem;
            color: #cccccc;
          }

          .MuiSvgIcon-root {
            color: #cccccc !important;
          }
        }

        .MuiTableBody-root {
          .MuiTableCell-root {
            font-size: 1.2rem;
          }

          .MuiTableCell-body {
            color: #cccccc;
          }

          .Mui-selected {
            background-color: rgba(0, 69, 245, 0.08);
          }

          .MuiCheckbox-root {
            color: #cccccc;
          }

          .Mui-checked {
            color: #136edb !important;
          }

          .MuiButtonBase-root {
            &:hover {
              background-color: rgba(0, 69, 245, 0.08);
            }
          }
        }
      }
    }

    .MuiTablePagination-root {
      color: #cccccc;

      .MuiTypography-root {
        font-size: 1.2rem;
      }

      .MuiSelect-root {
        font-size: 1.2rem;
      }

      .MuiSvgIcon-root {
        color: #cccccc;
      }
    }
  }

  .ReCAPTCHA {
    margin-top: 20px;
  }

  .buttons {
    margin: 40px 0;

    .help {
      background: none;
      border: 1px solid #fff;
      margin-right: 30px;
    }
  }
`;

export const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
  padding: 7px 14px;
  border-radius: 24px !important;
  height: 40px;
  width: 120px;
  & .MuiButton-label {
    color: #fff;
  }
`;
